var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _text, _g36, _text2, _text3, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tv",
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 1440,
    viewBox: "0 0 520 1440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    fill: "#1d1f31",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 1440,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 519,
    height: 1439,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "button-source",
    transform: "translate(149 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SOURCE",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.584,
    y: 0
  }, "SOURCE")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "button-menu",
    transform: "translate(49 738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-2",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MENU",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.176,
    y: 0
  }, "MENU")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "button-info",
    transform: "translate(149 738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-3",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "INFO",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.632,
    y: 0
  }, "INFO")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "button-tools",
    transform: "translate(-51 738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-4",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TOOLS",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.104,
    y: 0
  }, "TOOLS")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "button-guide",
    transform: "translate(-151 738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-5",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "GUIDE",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.432,
    y: 0
  }, "GUIDE")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "button-rec",
    transform: "translate(-251 738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-6",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "REC",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.592,
    y: 0
  }, "REC")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "button-tv",
    transform: "translate(-251 818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-7",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TV-2",
    "data-name": "TV",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.608,
    y: 0
  }, "TV")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "button-cc",
    transform: "translate(-251 898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-8",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CC",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.736,
    y: 0
  }, "CC")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "button-hdmi1",
    transform: "translate(-151 818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-9",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HDMI1",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.728,
    y: 0
  }, "HDMI1")))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "button-mts",
    transform: "translate(-151 898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-10",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MTS",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.4,
    y: 0
  }, "MTS")))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "button-manual",
    transform: "translate(-51 898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-11",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MANUAL",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.576,
    y: 0
  }, "MANUAL")))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "button-red",
    transform: "translate(-151 1078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-12",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#6e0b1c",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.872,
    y: 0
  }, "A")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "button-hdmi2",
    transform: "translate(-51 818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-13",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HDMI2",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.728,
    y: 0
  }, "HDMI2")))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "button-green",
    transform: "translate(-151 1158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-14",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#195e11",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.424,
    y: 0
  }, "B")))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "button-hdmi3",
    transform: "translate(49 818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-15",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HDMI3",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.728,
    y: 0
  }, "HDMI3")))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "button-yellow",
    transform: "translate(-151 1238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-16",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#8d7d15",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.416,
    y: 0
  }, "C")))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "button-hdmi4",
    transform: "translate(149 818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-17",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HDMI4",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.728,
    y: 0
  }, "HDMI4")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "button-blue",
    transform: "translate(-151 1318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-18",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#01408a",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "D",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.968,
    y: 0
  }, "D")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "button-smart-hub",
    transform: "translate(149 73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-19",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SMART_HUB",
    "data-name": "SMART HUB",
    transform: "translate(311 70)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.816,
    y: 0
  }, "SMART"), /*#__PURE__*/React.createElement("tspan", {
    x: -17.344,
    y: 16
  }, "HUB")))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "button-pic-size",
    transform: "translate(49 898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-20",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PIC_SIZE",
    "data-name": "PIC SIZE",
    transform: "translate(311 70)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.768,
    y: 0
  }, "PIC"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.592,
    y: 16
  }, "SIZE")))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "button-power",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(20 20)",
    fill: "#970303",
    stroke: "#440101",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "power-off-solid",
    d: "M46.889,5.367a24.6,24.6,0,1,1-28.591.01,2.388,2.388,0,0,1,3.472.764l1.567,2.788A2.38,2.38,0,0,1,22.682,12a16.665,16.665,0,1,0,19.831-.01,2.367,2.367,0,0,1-.645-3.065l1.567-2.788a2.378,2.378,0,0,1,3.452-.774ZM36.571,26.19V2.381A2.375,2.375,0,0,0,34.19,0H31.016a2.375,2.375,0,0,0-2.381,2.381V26.19a2.375,2.375,0,0,0,2.381,2.381H34.19A2.375,2.375,0,0,0,36.571,26.19Z",
    transform: "translate(27 35)",
    fill: "#fff"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "button-up",
    transform: "translate(-19 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-21",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(259 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "button-left",
    transform: "translate(-211 739) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-22",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    transform: "translate(258 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "button-right",
    transform: "translate(731 181) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-23",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1-3",
    "data-name": "Polygon 1",
    transform: "translate(259 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "button-down",
    transform: "translate(539 931) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-24",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1-4",
    "data-name": "Polygon 1",
    transform: "translate(258 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "button-enter",
    transform: "translate(23 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-25",
    "data-name": "Rectangle 2",
    transform: "translate(197 433)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "sign-in-alt-solid",
    d: "M40.625,101.5h-8.2a1.175,1.175,0,0,1-1.172-1.172V96.422a1.175,1.175,0,0,1,1.172-1.172h8.2a3.122,3.122,0,0,0,3.125-3.125V73.375a3.122,3.122,0,0,0-3.125-3.125h-8.2a1.175,1.175,0,0,1-1.172-1.172V65.172A1.175,1.175,0,0,1,32.422,64h8.2A9.377,9.377,0,0,1,50,73.375v18.75A9.377,9.377,0,0,1,40.625,101.5Zm-4.59-19.629L19.629,65.465a2.348,2.348,0,0,0-4,1.66V76.5H2.344A2.338,2.338,0,0,0,0,78.844v9.375a2.338,2.338,0,0,0,2.344,2.344H15.625v9.375a2.348,2.348,0,0,0,4,1.66L36.035,85.191A2.364,2.364,0,0,0,36.035,81.871Z",
    transform: "translate(212 390)",
    fill: "#fff"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "button-mute",
    transform: "translate(10 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-26",
    "data-name": "Rectangle 2",
    transform: "translate(390 340) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "volume-mute-solid",
    d: "M21,64.692,12.31,73.379H2.344A2.343,2.343,0,0,0,0,75.722V89.785a2.344,2.344,0,0,0,2.344,2.344H12.31L21,100.815a2.345,2.345,0,0,0,4-1.657V66.349A2.345,2.345,0,0,0,21,64.692ZM45.082,82.754,49.539,78.3a1.576,1.576,0,0,0,0-2.228L47.31,73.84a1.576,1.576,0,0,0-2.228,0L40.625,78.3,36.168,73.84a1.576,1.576,0,0,0-2.228,0l-2.228,2.229a1.576,1.576,0,0,0,0,2.228l4.457,4.457L31.712,87.21a1.576,1.576,0,0,0,0,2.229l2.228,2.228a1.576,1.576,0,0,0,2.228,0l4.456-4.456,4.457,4.457a1.576,1.576,0,0,0,2.228,0l2.228-2.229a1.576,1.576,0,0,0,0-2.228Z",
    transform: "translate(325 216.996)",
    fill: "#fff"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(500 400) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 180,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 177,
    rx: 8.5,
    fill: "none"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "button-vol-up",
    transform: "translate(20 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-27",
    "data-name": "Rectangle 2",
    transform: "translate(480 340) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "volume-up-solid",
    d: "M17.919,20.583,10.505,28H2a2,2,0,0,0-2,2V42a2,2,0,0,0,2,2h8.505l7.414,7.413a2,2,0,0,0,3.414-1.414V22A2,2,0,0,0,17.919,20.583Zm19.443-4.257A2.017,2.017,0,1,0,35.149,19.7a19.471,19.471,0,0,1,0,32.6,2.016,2.016,0,1,0,2.213,3.371,23.5,23.5,0,0,0,0-39.339ZM40,36a15.386,15.386,0,0,0-7.147-13.02,1.991,1.991,0,0,0-2.76.622,2.024,2.024,0,0,0,.618,2.78,11.389,11.389,0,0,1,0,19.237,2.023,2.023,0,0,0-.618,2.78,2,2,0,0,0,2.76.622A15.385,15.385,0,0,0,40,36ZM28.186,29.59a2,2,0,0,0-1.93,3.505,3.285,3.285,0,0,1,0,5.8,2,2,0,0,0,1.93,3.505,7.286,7.286,0,0,0,0-12.812Z",
    transform: "translate(416 264.005)",
    fill: "#fff"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "button-vol-down",
    transform: "translate(20 -40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-28",
    "data-name": "Rectangle 2",
    transform: "translate(480 440) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "volume-down-solid",
    d: "M19.6,65.641,11.49,73.749h-9.3A2.187,2.187,0,0,0,0,75.936V89.061a2.187,2.187,0,0,0,2.187,2.187h9.3L19.6,99.356a2.189,2.189,0,0,0,3.734-1.547V67.188A2.189,2.189,0,0,0,19.6,65.641Zm11.229,9.851a2.188,2.188,0,1,0-2.111,3.833,3.593,3.593,0,0,1,0,6.346A2.188,2.188,0,1,0,30.828,89.5a7.97,7.97,0,0,0,0-14.013Z",
    transform: "translate(423 318.001)",
    fill: "#fff"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "button-ch-list",
    transform: "translate(100 -160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-29",
    "data-name": "Rectangle 2",
    transform: "translate(100 460) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CH_LIST",
    "data-name": "CH LIST",
    transform: "translate(60 420)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.512,
    y: 0
  }, "CH"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.248,
    y: 16
  }, "LIST")))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(100 400) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 180,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 177,
    rx: 8.5,
    fill: "none"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "button-ch-down",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-30",
    "data-name": "Rectangle 2",
    transform: "translate(100 460) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "minus-solid",
    d: "M44.571,208H3.429A3.429,3.429,0,0,0,0,211.429v3.429a3.429,3.429,0,0,0,3.429,3.429H44.571A3.429,3.429,0,0,0,48,214.857v-3.429A3.429,3.429,0,0,0,44.571,208Z",
    transform: "translate(36 207)",
    fill: "#fff"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "button-ch-up",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-31",
    "data-name": "Rectangle 2",
    transform: "translate(100 360) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "plus-solid",
    d: "M44.571,50.857H29.143V35.429A3.429,3.429,0,0,0,25.714,32H22.286a3.429,3.429,0,0,0-3.429,3.429V50.857H3.429A3.429,3.429,0,0,0,0,54.286v3.429a3.429,3.429,0,0,0,3.429,3.429H18.857V76.571A3.429,3.429,0,0,0,22.286,80h3.429a3.429,3.429,0,0,0,3.429-3.429V61.143H44.571A3.429,3.429,0,0,0,48,57.714V54.286A3.429,3.429,0,0,0,44.571,50.857Z",
    transform: "translate(36 264)",
    fill: "#fff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "VOL",
    transform: "translate(460 213)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.016,
    y: 0
  }, "VOL"))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "button-return",
    transform: "translate(100 60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-32",
    "data-name": "Rectangle 2",
    transform: "translate(400 540) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "undo-alt-solid",
    d: "M25.967,8a17.939,17.939,0,0,0-12.4,4.985l-2.592-2.592A1.742,1.742,0,0,0,8,11.624v9.73A1.742,1.742,0,0,0,9.742,23.1h9.73A1.742,1.742,0,0,0,20.7,20.123l-3.03-3.03a12.193,12.193,0,1,1,.3,18.085.87.87,0,0,0-1.188.04L13.9,38.1a.873.873,0,0,0,.035,1.265A18,18,0,1,0,25.967,8Z",
    transform: "translate(334 468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RETURN",
    transform: "translate(360 531)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.28,
    y: 0
  }, "RETURN")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "CH",
    transform: "translate(60 213)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.512,
    y: 0
  }, "CH"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "TV-3",
    "data-name": "TV",
    transform: "translate(60 33)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.608,
    y: 0
  }, "TV"))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "button-pause",
    transform: "translate(0 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-33",
    "data-name": "Rectangle 2",
    transform: "translate(400 680) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "pause-solid",
    d: "M11.571,67H3.857A3.858,3.858,0,0,1,0,63.143V34.857A3.858,3.858,0,0,1,3.857,31h7.714a3.858,3.858,0,0,1,3.857,3.857V63.143A3.858,3.858,0,0,1,11.571,67ZM36,63.143V34.857A3.858,3.858,0,0,0,32.143,31H24.429a3.858,3.858,0,0,0-3.857,3.857V63.143A3.858,3.858,0,0,0,24.429,67h7.714A3.858,3.858,0,0,0,36,63.143Z",
    transform: "translate(342 591)",
    fill: "#fff"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "button-play",
    transform: "translate(0 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    transform: "translate(300 680) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "play-solid",
    d: "M29.839,15.125,5.09.494A3.356,3.356,0,0,0,0,3.4V32.653a3.372,3.372,0,0,0,5.09,2.9L29.839,20.933a3.371,3.371,0,0,0,0-5.808Z",
    transform: "translate(244 621.968)",
    fill: "#fff"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "button-stop",
    transform: "translate(0 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    transform: "translate(200 680) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "stop-solid",
    d: "M32.143,32H3.857A3.858,3.858,0,0,0,0,35.857V64.143A3.858,3.858,0,0,0,3.857,68H32.143A3.858,3.858,0,0,0,36,64.143V35.857A3.858,3.858,0,0,0,32.143,32Z",
    transform: "translate(142 590)",
    fill: "#fff"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "button-reverse",
    transform: "translate(0 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    transform: "translate(100 680) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "backward-solid",
    d: "M1.1,84.262l18,15a3,3,0,0,0,4.922-2.306v-30A3,3,0,0,0,19.1,64.648l-18,15A3.01,3.01,0,0,0,1.1,84.262Zm24,0,18,15a3,3,0,0,0,4.922-2.306v-30A3,3,0,0,0,43.1,64.648l-18,15A3.01,3.01,0,0,0,25.1,84.262Z",
    transform: "translate(35.975 558.05)",
    fill: "#fff"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "button-forward",
    transform: "translate(0 50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-sq-base",
    transform: "translate(420 600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(80 80) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "forward-solid",
    d: "M46.924,79.689l-18-15A3,3,0,0,0,24,66.994V97A3,3,0,0,0,28.923,99.3l18-15A3.01,3.01,0,0,0,46.924,79.689Zm-24,0-18-15A3,3,0,0,0,0,66.994V97A3,3,0,0,0,4.922,99.3l18-15A3.01,3.01,0,0,0,22.923,79.689Z",
    transform: "translate(436 558.006)",
    fill: "#fff"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "button-exit",
    transform: "translate(-300 260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-sq-base-2",
    "data-name": "button-sq-base",
    transform: "translate(320 260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5-2",
    "data-name": "Rectangle 5",
    transform: "translate(80 80) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "EXIT",
    transform: "translate(360 329)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.824,
    y: 0
  }, "EXIT")), /*#__PURE__*/React.createElement("path", {
    id: "times-solid",
    d: "M24.824,98,35.058,87.766a3.217,3.217,0,0,0,0-4.549l-2.275-2.275a3.217,3.217,0,0,0-4.549,0L18,91.176,7.766,80.942a3.217,3.217,0,0,0-4.549,0L.942,83.216a3.217,3.217,0,0,0,0,4.549L11.176,98,.942,108.234a3.217,3.217,0,0,0,0,4.549l2.275,2.275a3.217,3.217,0,0,0,4.549,0L18,104.824l10.234,10.234a3.217,3.217,0,0,0,4.549,0l2.275-2.275a3.217,3.217,0,0,0,0-4.549Z",
    transform: "translate(342 194)",
    fill: "#fff"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "button-1",
    transform: "translate(0 120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "1")))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "button-4",
    transform: "translate(0 220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-2",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "4")))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "button-2",
    transform: "translate(100 120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-3",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "2")))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "button-5",
    transform: "translate(100 220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-4",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "5")))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "button-3",
    transform: "translate(200 120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-5",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "3")))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "button-6",
    transform: "translate(200 220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-6",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": 6,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.381,
    y: 0
  }, "6")))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "button-7",
    transform: "translate(0 320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-7",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "7")))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "button-dash",
    transform: "translate(0 420)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-8",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_-",
    "data-name": "-",
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.151,
    y: 0
  }, "-")))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "button-8",
    transform: "translate(100 320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-9",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "8")))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "button-9",
    transform: "translate(200 320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-10",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_9",
    "data-name": 9,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "9")))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "button-0",
    transform: "translate(100 420)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1-11",
    "data-name": "Path 1",
    transform: "translate(220 920)",
    fill: "#324357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70 78.5 L 10 78.5 C 5.313088893890381 78.5 1.5 74.68691253662109 1.5 70 L 1.5 10 C 1.5 5.313088893890381 5.313088893890381 1.5 10 1.5 L 70 1.5 C 74.68691253662109 1.5 78.5 5.313088893890381 78.5 10 L 78.5 70 C 78.5 74.68691253662109 74.68691253662109 78.5 70 78.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 3 C 6.140190124511719 3 3 6.140190124511719 3 10 L 3 70 C 3 73.85980987548828 6.140190124511719 77 10 77 L 70 77 C 73.85980987548828 77 77 73.85980987548828 77 70 L 77 10 C 77 6.140190124511719 73.85980987548828 3 70 3 L 10 3 M 10 0 L 70 0 C 75.52285003662109 0 80 4.477149963378906 80 10 L 80 70 C 80 75.52285003662109 75.52285003662109 80 70 80 L 10 80 C 4.477149963378906 80 0 75.52285003662109 0 70 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#0a0d10"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(260 973)",
    fill: "#fff",
    fontSize: 38,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.4,
    y: 0
  }, "0")))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "button-pre-ch",
    transform: "translate(400 960)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-34",
    "data-name": "Rectangle 2",
    transform: "translate(100 460) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "PRE_CH",
    "data-name": "PRE CH",
    transform: "translate(60 420)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.416,
    y: 0
  }, "PRE"), /*#__PURE__*/React.createElement("tspan", {
    x: -11.512,
    y: 16
  }, "CH")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.b60874d28643ce31173835503197e3f4.svg";
export { ForwardRef as ReactComponent };